
import icons from 'url:./../../img/icons.svg'
export default class View {
  _data;
  /**
   * Render the received object to the DOM
   * @param {object | object[]} data  the data to be rendered(e.g recipe)
   * @returns {string} A markup string is returned
   * @this {object} View instance 
   * @author Hamed Ostovar
   * @todo Finish implementation 
    */
  render(data) {
    if (!data || (Array.isArray(data) && data?.length === 0)) return this.renderError("There is no recipe item");

    this._data = data;

    const markup = this._generateMarkup();
    this._clear();
    this._parentElement.insertAdjacentHTML("afterbegin", markup)
  }
  /**
   * empty the parent element
   * @returns {string} empty string
   */
  _clear() {
    this._parentElement.innerHTML = ""
  }

  /**
   * @returns {string} A markup string is returned
   */
  renderSpinner() {
    const markup =
      `
              <div class="spinner">
              <svg>
                <use href="${icons}#icon-loader"></use>
              </svg>
              </div>
            `;
    this._clear();
    this._parentElement.insertAdjacentHTML("afterbegin", markup)
  }

  /**
   * 
   * @param {string} message
   * @returns {string}  A markup string is returned
   *  
   */
  renderError(message = this._errorMessage) {
    const markup = `
            <div class="error">
            <div>
              <svg>
                <use href="${icons}#icon-alert-triangle"></use>
              </svg>
            </div>
            <p>${message}</p>
          </div>
            `
    this._clear();
    this._parentElement.insertAdjacentHTML("afterbegin", markup)
  }

}